var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoaNetworkPoa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    id: "poa-network-poa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5332A0",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5332A0",
    fillRule: "evenodd",
    d: "M6.82603 12.9171H6.56662V13.5995C6.56411 13.7284 6.44777 13.8311 6.30656 13.8291H4.22865C4.16075 13.8299 4.09525 13.8062 4.04659 13.7629 3.99793 13.7197 3.9701 13.6606 3.96924 13.5986V9.47053H3.97088C3.97088 9.46813 3.97088 9.46603 3.97088 9.46363 3.9725 9.33504 4.08775 9.23186 4.22865 9.23286H6.82603C7.97302 9.23286 8.90296 10.0573 8.90296 11.0745 8.90296 12.0917 7.97204 12.9171 6.82603 12.9171zM12.0175 9.23286C13.4512 9.23286 14.6116 10.2614 14.6116 11.5307 14.6116 12.7999 13.4495 13.8282 12.0175 13.8282 10.5855 13.8282 9.42014 12.7996 9.42014 11.5307 9.42014 10.2617 10.5835 9.23286 12.0175 9.23286zM20.5846 13.6828C20.5839 13.721 20.5666 13.7575 20.5365 13.7841 20.5064 13.8106 20.4659 13.8252 20.424 13.8246H14.5358C14.529 13.8263 14.5221 13.8275 14.5151 13.8282 14.4728 13.8286 14.4321 13.8138 14.4019 13.7869 14.3716 13.7599 14.3544 13.7232 14.3539 13.6846 14.3548 13.6548 14.3663 13.6261 14.3867 13.6028L14.3837 13.5977 17.3075 9.34405H17.3138C17.3298 9.27813 17.3939 9.23123 17.4679 9.23123 17.5419 9.23123 17.606 9.27813 17.6221 9.34405H17.6287L20.584 13.6262 20.5738 13.6385C20.5801 13.6526 20.5837 13.6676 20.5846 13.6828V13.6828z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoaNetworkPoa);
export default __webpack_public_path__ + "static/media/poa-network-poa.db329df0751687ca2379e7d5fb593bdd.svg";
export { ForwardRef as ReactComponent };